import { ChangeDetectionStrategy, Component, effect, input, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PerioNumberSelectorComponent } from '../perio-number-selector/perio-number-selector.component';

export interface PerioJawMeasurements {
  mob: number;
  fg: number;
}

@Component({
  selector: 'lib-perio-jaw-related-measurements',
  imports: [PerioNumberSelectorComponent, ReactiveFormsModule, TranslateModule],
  templateUrl: './perio-jaw-related-measurements.component.html',
  styleUrl: './perio-jaw-related-measurements.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioJawRelatedMeasurementsComponent implements OnInit {
  public measurements = input.required<PerioJawMeasurements>();
  public fgDisabled = input<boolean>(false);
  public reversed = input<boolean>(false);
  public measurementChange = output<PerioJawMeasurements>();
  protected formGroup = new FormGroup({
    mob: new FormControl<number>(0, { nonNullable: true }),
    fg: new FormControl<number>(0, { nonNullable: true }),
  });

  public ngOnInit(): void {
    this.formGroup.valueChanges.subscribe((flags) => {
      this.measurementChange.emit(flags as PerioJawMeasurements);
    });
  }

  constructor() {
    effect(() => {
      const { mob, fg } = this.measurements();

      if (mob !== this.mobControl!.value) {
        this.mobControl!.setValue(mob, { emitEvent: false });
      }

      if (fg !== this.fgControl!.value) {
        this.fgControl!.setValue(fg, { emitEvent: false });
      }
    });
  }

  private readonly mobControl = this.formGroup.get('mob');
  private readonly fgControl = this.formGroup.get('fg');
}
